import { IssueCaseDoc, IssueCaseStatusCode } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';
import { map } from 'rxjs';

import { observeIssueCases } from 'src/utils/firebase/firebase-short-cut';

interface UseRecentValidIssueCasesOptions {
  limit?: number;
}

const VALID_STATUSES = [
  IssueCaseStatusCode.PENDING,
  IssueCaseStatusCode.OPEN,
  IssueCaseStatusCode.IN_PROGRESS,
  IssueCaseStatusCode.CLOSED,
];

export const useRecentValidIssueCases = (storeId: string | null, options: UseRecentValidIssueCasesOptions = {}) => {
  const { limit = 10 } = options;
  const [issueCases, setIssueCases] = useState<IssueCaseDoc[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!storeId) {
      setIssueCases([]);
      return;
    }

    setIsLoading(true);

    // status 조건은 색인 영향 최소화를 위해 클라이언트에서 필터링
    const subscription = observeIssueCases([['storeId', '==', storeId]], {
      sortKey: 'registeredAt',
      orderBy: 'desc',
      limit: limit * 3,
    })
      .pipe(map((cases) => cases.filter((c) => VALID_STATUSES.includes(c.status)).slice(0, limit)))
      .subscribe({
        next: (cases) => {
          setIssueCases(cases);
          setIsLoading(false);
        },
        error: (err) => {
          console.error('Failed to fetch recent valid issue cases:', err);
          setIsLoading(false);
        },
      });

    return () => subscription.unsubscribe();
  }, [storeId, limit]);

  return { issueCases, isLoading };
};
